module.exports = __webpack_public_path__ + "static/media/pasta.756bafbe.png";